/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from "react";
import { AppRoot, PageContainer } from "./src/PageContainer";
import "./src/polyfill";

export const wrapPageElement = ({ element, props }) => {
  return <PageContainer {...props}>{element}</PageContainer>;
};

export const wrapRootElement = ({ element }) => {
  return <AppRoot>{element}</AppRoot>;
};

export const onClientEntry = async () => {
  if (typeof IntersectionObserver === `undefined`) {
    await import(`intersection-observer`);
    window.__GATSBY_INITIAL_PROPS = window.__GATSBY_INITIAL_PROPS || {};
  }
};

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (process.env.NODE_ENV !== "production") {
    console.log("路由更新:", location.pathname);
    console.log("前一個路由:", prevLocation ? prevLocation.pathname : null);
  }
};
